import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import pt from "./locales/pt";
import en from "./locales/en";

export const IDIOMAS = [
  { code: "pt", label: "Português" },
  { code: "en", label: "English" },
] as const;

export type IdiomaCode = (typeof IDIOMAS)[number]["code"];

const STORAGE_KEY = "idioma";

function idiomaInicial(): IdiomaCode {
  if (typeof window === "undefined") return "pt";
  const salvo = window.localStorage.getItem(STORAGE_KEY);
  return salvo === "en" || salvo === "pt" ? salvo : "pt"; // padrão pt-BR
}

i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: pt },
    en: { translation: en },
  },
  lng: idiomaInicial(),
  fallbackLng: "pt",
  interpolation: {
    escapeValue: false, // React já faz o escape
  },
});

export function mudarIdioma(code: IdiomaCode) {
  window.localStorage.setItem(STORAGE_KEY, code);
  i18n.changeLanguage(code);
  if (typeof document !== "undefined") {
    document.documentElement.lang = code === "pt" ? "pt-BR" : "en";
  }
}

// Garante que o atributo lang do <html> reflita o idioma inicial.
if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language === "en" ? "en" : "pt-BR";
}

export default i18n;
